export default "__VITE_ASSET__0df8223c__"